<template>
  <header>
    <CenterWrapper class="header__wrapper">
      <div class="header__left"></div>
      <div class="header__middle logos">
        <LogoSquare size="50"/>
        <LogoSlack size="100"/>
      </div>
      <div class="header__right">
        <SvgChat
          class="header__button-right"
          @click="$router.push('/scheduleMessages')"
        />
        <SvgSettings
          v-if="isCordova"
          class="header__button-right"
          @click="navigateSettings"
        />
        <SvgLogout
          class="header__button-right"
          @click="logout"
        />
      </div>
    </CenterWrapper>
  </header>
</template>

<script>
import LogoSlack from '@/assets/LogoSlack';
import LogoSquare from '@/assets/LogoSquare';
import SvgChat from '@/assets/SvgChat';
import SvgLogout from '@/assets/SvgLogout';
import SvgSettings from '@/assets/SvgSettings';
import {
  logout,
} from '@/auth';
import CenterWrapper from '@/components/CenterWrapper';
import {
  isCordova,
} from '@/utils';

export default {
  name: 'Header',
  components: {
    LogoSlack,
    LogoSquare,
    SvgChat,
    SvgLogout,
    SvgSettings,
    CenterWrapper,
  },
  data() {
    return {
      isCordova,
    };
  },
  methods: {
    navigateSettings() {
      this.$router.replace('/settings');
    },
    logout() {
      logout();
    },
  },
};
</script>

<style scoped>
header {
  position: relative;
  min-height: 100px;
  text-align: center;
  background-color: lightgray;
}

.header__wrapper {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.header__left,
.header__right {
  flex: 1;
  display: flex;
  flex-direction: row;
}

.header__right {
  justify-content: flex-end;
}

.header__button-right {
  margin-left: 10px;
}

.logos {
  display: flex;
  justify-content: center;
  align-items: center;
}

@media (max-width: 768px) {
  .header__left {
    width: 0;
    flex: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue